import jQuery from 'jquery';
import 'metismenu';

function SideNavigation($timeout) {
    return {
        restrict: 'A',
        link: function(scope, element) {
            // Call the metsiMenu plugin and plug it to sidebar navigation
            $timeout(function() {
                jQuery(element).metisMenu();
            });
        }
    };
};

SideNavigation.$inject=['$timeout'];

export {SideNavigation};



// WEBPACK FOOTER //
// ./app/components/common/navbar/navigation.directive.js